
          import "Select.styles_yulybd.linaria.css";
          import React from "react";
import { styled } from "@linaria/react";
import { focusStyle, typeStyle } from "@carvana/showroom-css-theme";
export const SelectWrapper = /*#__PURE__*/styled("div")({
  name: "SelectWrapper",
  class: "s1nf4q5s"
});
export const SelectInput = /*#__PURE__*/styled("button")({
  name: "SelectInput",
  class: "ss0njt0"
});
export const SelectCaption = /*#__PURE__*/styled("p")({
  name: "SelectCaption",
  class: "sx3rssh"
});
export const OptionWrapper = /*#__PURE__*/styled("div")({
  name: "OptionWrapper",
  class: "o519fet"
});
export const OptionsContainer = /*#__PURE__*/styled("div")({
  name: "OptionsContainer",
  class: "o1s0jnet"
});
const Path = /*#__PURE__*/styled("path")({
  name: "Path",
  class: "phuhfvz",
  vars: {
    "phuhfvz-0": [({
      fill
    }) => fill || "var(--cvna-color-blue-2)"]
  }
});
export const CaretDown = ({
  disabled
}) => /* @__PURE__ */React.createElement("svg", {
  width: "9",
  height: "5",
  viewBox: "0 0 9 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */React.createElement(Path, {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 5.45614L0 0.543861H9L4.5 5.45614Z",
  className: disabled && "is-disabled"
}));
export const CaretUp = () => /* @__PURE__ */React.createElement("svg", {
  width: "9",
  height: "5",
  viewBox: "0 0 9 5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */React.createElement(Path, {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 0L0 5H9L4.5 0Z"
}));
export const Checkmark = () => /* @__PURE__ */React.createElement("svg", {
  width: "9",
  height: "7",
  viewBox: "0 0 9 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */React.createElement(Path, {
  d: "M3.10104 7L0.272375 4.27132C-0.0907918 3.90632 -0.0907918 3.34196 0.272375 2.97695C0.444094 2.80521 0.684592 2.70769 0.9364 2.70769C1.18821 2.70769 1.42871 2.80521 1.60042 2.97695L3.10104 4.43224L7.40032 0.269263C7.57204 0.0975222 7.81254 0 8.06435 0C8.31615 0 8.55665 0.0975222 8.72837 0.269263C9.09054 0.631941 9.09054 1.19396 8.72837 1.55664L3.10104 7Z"
}));
export const CheckboxOn = () => /* @__PURE__ */React.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  className: "icon-checkbox-on"
}, /* @__PURE__ */React.createElement("rect", {
  width: "100%",
  height: "100%",
  fill: "#fff",
  rx: "3"
}), /* @__PURE__ */React.createElement(Path, {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3Zm13.766 9.697a1 1 0 0 0-1.532-1.286l-4.877 5.806-.078-.083-1.551-1.645a1 1 0 0 0-1.456 1.372l1.552 1.645.605.642.179.19.048.05.012.014.003.003.001.001.728-.686-.728.686a1 1 0 0 0 1.494-.042l5.6-6.667Z"
}));
export const CheckboxOff = () => /* @__PURE__ */React.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */React.createElement(Path, {
  d: "M21 .5H3A2.5 2.5 0 0 0 .5 3v18A2.5 2.5 0 0 0 3 23.5h18a2.5 2.5 0 0 0 2.5-2.5V3A2.5 2.5 0 0 0 21 .5Z",
  stroke: "currentColor",
  fill: "none"
}));
          